/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertTimeOff} from '../api'

export const useMutationUpsertTimeOff = createReactQueryMutationHook('upsertTimeOff', upsertTimeOff)
